import type { FC, ReactNode } from "react";

import { Card, type GridCard } from "widgets";

import { TranscriptTile } from "../../core/tiles/index.js";
import { getSourceString } from "@/app-utils/string.ts";
import type { Transcript } from "@/graphql.ts";
import { SelMessage } from "@/messages/SelMessage.tsx";

export interface ITranscriptListCardProps extends GridCard {
  transcripts: Transcript[];
  ignoreIfEmpty?: boolean; // should this be called hideIfEmpty ?
  title?: string;
  showSource?: boolean;
}

const TranscriptListCard: FC<ITranscriptListCardProps> = (props) => {
  const transcripts: Transcript[] = props.transcripts;
  if (props.ignoreIfEmpty && (!transcripts || transcripts.length === 0)) {
    return null;
  }

  let elements: ReactNode = <SelMessage id={"noContent.relatedTranscripts"} />;

  if (transcripts && transcripts.length > 0) {
    elements = transcripts.map((transcript: Transcript) => {
      const sourceHint = props.showSource ? getSourceString(transcript.genome, transcript.database) : undefined;
      return (
        <TranscriptTile
          transcript={transcript}
          footNote={sourceHint}
          key={`transcript-card-elem-${transcript.id}`}
          hideIcon
          type={null}
        />
      );
    });
  }

  return (
    <Card title={props.title ?? "Transcripts"} tag={{ label: String(transcripts.length) }} icon={"sticky_note_2"}>
      {elements}
    </Card>
  );
};

export { TranscriptListCard };
